import React from 'react'
import PropTypes from 'prop-types'
import { Helmet } from 'react-helmet'
import { withPrefix } from 'gatsby'
import Footer from '../components/Footer'
import Navbar from '../components/Navbar'
import useSiteMetadata from '../components/SiteMetadata'
import image from '../../static/img/og-image.jpg'

const TemplateWrapper = ({ children }) => {
  const { title, description } = useSiteMetadata()
  return (
    <div>
      <Helmet>
        <html lang='en' />
        <title>{title}</title>
        <meta name='description' content={description} />

        <link
          rel='apple-touch-icon'
          sizes='180x180'
          href={`${withPrefix('/')}img/favicon-16x16.svg`}
        />
        <link
          rel='icon'
          type='image/png'
          href={`${withPrefix('/')}img/favicon-32x32.svg`}
          sizes='32x32'
        />
        <link
          rel='icon'
          type='image/png'
          href={`${withPrefix('/')}img/favicon-16x16.svg`}
          sizes='16x16'
        />

        <link
          rel='mask-icon'
          href={`${withPrefix('/')}img/safari-pinned-tab.svg`}
          color='#ff4400'
        />
        <meta name='theme-color' content='#fff' />

        <meta property='og:type' content='business.business' />
        <meta property='og:title' content={title} />
        <meta property='og:url' content='/' />
        <meta
          property='og:image'
          content='https://soulcast.netlify.app/static/og-image-a415d7f250a15d5cee3556ae1f9e4210.jpg'
        />
        <meta name='image' content={image} />
        <meta name='twitter:card' content='summary_large_image' />
        <meta name='twitter:description' content='Find your love based on podcasts you listen to.' />
        <meta name='twitter:image' content='https://soulcast.netlify.app/static/og-image-a415d7f250a15d5cee3556ae1f9e4210.jpg' />
      </Helmet>
      <Navbar />
      <div>{children}</div>
      <Footer />
    </div>
  )
}

TemplateWrapper.propTypes = {
  children: PropTypes.any,
}

export default TemplateWrapper
